import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from '../shared/services/configuration.service';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { TagModel } from '../models/tag.model';

@Injectable({
  providedIn: 'root'
})
export class TagService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);

  private backUrl;

  constructor() {
    this.backUrl = `${this.configSvc.workloadsApiUrl}api`;
  }

  addTag(model: TagModel): Observable<any> {
    return this.http.post(`${this.backUrl}/Tags`, model);
  }

  updateTag(model: TagModel): Observable<any> {
    return this.http.patch(`${this.backUrl}/Tags/${model.id}`, model);
  }

  getTags(): Observable<Array<TagModel>> {
    return this.http.get<Array<TagModel>>(`${this.backUrl}/Tags`);
  }

  deleteTag(tagId: string): Observable<any> {
    return this.http.delete<any>(`${this.backUrl}/Tags/${tagId}`);
  }

  addTagToTask(tagId: any, taskId: any): Observable<any> {
    return this.http.post(`${this.backUrl}/Tags/${tagId}/task/${taskId}`, null);
  }

  deleteTagToTask(tagId: any, taskId: any): Observable<any> {
    return this.http.delete<any>(`${this.backUrl}/Tags/${tagId}/task/${taskId}`);
  }

  getTaskTagByTaskId(taskId: any): Observable<Array<TagModel>> {
    return this.http.get<Array<TagModel>>(`${this.backUrl}/Tags/task/${taskId}`);
  }

  countTaskTagByTagId(tagId: any): Observable<number> {
    return this.http.get<number>(`${this.backUrl}/Tags/${tagId}/count`);
  }
}
